var exports = {};
exports = window.FormData;
export default exports;